export default __webpack_public_path__ + "static/media/droid.475efa44.ttf";